import styled from 'styled-components';

export const StyledTable = styled.div`
  display: table;
  width: calc(100% - 35px);
  margin: 15px;
  padding-left: 5px;
  background-color: #dadada;
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.1);
`;

export const StyledTableCaption = styled.div`
  display: table-caption;
  background-color: #dadada;
`;

export const StyledTableHeader = styled.div`
  background-color: #ffffff;
  margin-left: 5px;
  padding: 15px;
  font-size: 130%;
  font-weight: bold;
`;

export const StyledTableIntro = styled.div`
  background-color: #ffffff;
  margin-left: 5px;
  padding: 15px;
`;

export const StyledTableRowGroup = styled.div`
  display: table-row-group;
`;

export const StyledTableRow = styled.div`
  display: table-row;
  background-color: #ffffff;
`;

export const StyledTableCell = styled.div`
  display: table-cell;
  padding: 3px;
  vertical-align: top;
  &:first-child {
    padding-left: 15px;
    width: 300px;
  }
`;

export const StyledInputText = styled.input`
  min-width: 400px;
  padding: 2px;
`;

export const StyledErrorFor = styled.label`
  padding-left: 15px;
`;

export const StyledShortCode = styled.textarea`
  min-width: 400px;
  min-height: 100px;
  padding: 2px;
`;

export const StyledCopyButton = styled.button`
  min-width: 400px;
  min-height: 25px;
  padding: 2px;
`;
